// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.checkbox-with-input[data-v-06918b75] {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: flex-start;\n  font-size: 14px;\n}\n.text-input[data-v-06918b75] {\n  width: 10%;\n  margin: 0 0;\n  padding: 0 1%;\n  align-content: center;\n  justify-content: center;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
